<i *ngIf="!!type" class="ph-bold alert-block-icon icon-20" [ngClass]="phIcon" aria-hidden="true"></i>
<div class="alert-block-content"><ng-content></ng-content></div>
<button *ngIf="dismissible"
        mat-icon-button
        [disableRipple]="true"
        class="close-button"
        (click)="onDismiss()"
        [attr.aria-label]="'Dismiss'">
    <i class="ph-bold ph-x icon-muted icon-16" aria-hidden="true"></i>
</button>
